class CartDebouncer {
  constructor() {
    this.pendingUpdates = new Map();
    this.updateTimer = null;
    this.batchDelay = 300;
    this.isProcessing = false;
    this.subscribers = new Set();
  }

  subscribe(callback) {
    this.subscribers.add(callback);
    return () => this.subscribers.delete(callback);
  }

  queueUpdate(productId, updateData) {
    this.pendingUpdates.set(productId, {
      ...updateData,
      timestamp: Date.now()
    });

    if (this.updateTimer) {
      clearTimeout(this.updateTimer);
    }

    this.updateTimer = setTimeout(() => {
      this.processBatch();
    }, this.batchDelay);
  }

  processBatch() {
    if (this.isProcessing || this.pendingUpdates.size === 0) {
      return;
    }

    this.isProcessing = true;
    const updates = Array.from(this.pendingUpdates.entries());
    this.pendingUpdates.clear();

    this.subscribers.forEach(callback => {
      try {
        callback(updates);
      } catch (error) {
        console.error('[CartDebouncer] Subscriber error:', error);
      }
    });

    this.isProcessing = false;
  }

  flush() {
    if (this.updateTimer) {
      clearTimeout(this.updateTimer);
      this.updateTimer = null;
    }
    this.processBatch();
  }

  getPendingCount() {
    return this.pendingUpdates.size;
  }

  clear() {
    if (this.updateTimer) {
      clearTimeout(this.updateTimer);
      this.updateTimer = null;
    }
    this.pendingUpdates.clear();
  }
}

export const cartDebouncer = new CartDebouncer();
export const withCartPerformance = (operation, context = 'cart-operation') => {
  const start = performance.now();
  const result = operation();
  const duration = performance.now() - start;
  
  if (duration > 50) {
    console.warn(`[CartPerformance] Slow ${context}: ${Math.round(duration)}ms`);
  }
  
  return result;
};